import store from '@/store'

export const notify = (isNotifSuccess, isNotifVisible, notifMessage) => {
  store.state.user.notifMessage = notifMessage
  store.state.user.isNotifSuccess = isNotifSuccess
  store.state.user.isNotifVisible = isNotifVisible
}
